import React from "react";
import { Alert, Paper, Stack } from "@mui/material";
import { spacing } from "../../styles/theme";
import SpecsPositionIdentitySection from "./SpecsPositionIdentitySection";
import SpecsPositionSidesSection from "./SpecsPositionSidesSection";
import SpecsPositionTechpackSection from "./SpecsPositionTechpackSection";
import SpecsPositionStyleAssignmentsSection from "./SpecsPositionStyleAssignmentsSection";
import { useSpecsEditorContextValue } from "./useSpecsEditor";
import { useSpecsModelSelector } from "./SpecsModelContext";

export default function SpecsPositionEditorMainContent() {
  const {
    editor: {
      identity: { productVersion },
    },
    selectedPositionId,
  } = useSpecsEditorContextValue();
  const hasSelectedPosition = useSpecsModelSelector(
    (model) =>
      !!selectedPositionId &&
      !!model
        .getVersion(productVersion)
        ?.positions.some((position: any) => position.id === selectedPositionId)
  );

  if (!hasSelectedPosition) {
    return (
      <Alert severity="info">
        Import a product with positions or add a new position to start editing.
      </Alert>
    );
  }

  return (
    <Paper
      variant="outlined"
      sx={{ p: spacing.groupingDesktop, mb: spacing.groupingDesktop }}
    >
      <Stack spacing={2}>
        <SpecsPositionIdentitySection />
        <SpecsPositionSidesSection />
        <SpecsPositionTechpackSection />
        <SpecsPositionStyleAssignmentsSection />
      </Stack>
    </Paper>
  );
}
